import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import type { User } from '../Types/interfaces';
import { GetUser } from '../helper/apiHelper';

const defaultUser: User = {
  id: 0,
  lastName: '',
  firstName: '',
  email: '',
  phoneNumber: '',
  roles: 0,
  accessToken: '',
};

export const useCurrentUser = (): User => {
  const queryClient = useQueryClient();

  // use eslint disable to prevent the warning of missing dependency in useQuery
  // we don't want to add queryClient in dependency array because we won't be able to update user from other components
  // eslint-disable-next-line
  const { data: user } = useQuery({
    queryKey: QUERY_KEYS.USER,
    queryFn: async () => {
      const cachedUser = queryClient.getQueryData<User>(QUERY_KEYS.USER);
      if (cachedUser && cachedUser.id !== 0) {
        return await GetUser(String(cachedUser.id));
      }
      return defaultUser;
    },
    staleTime: Infinity, // never refetch automatically and queryFn not run again to rewrite user data with default user data, only return cached user data
  });

  return user || defaultUser; // if no user return default user, because while fetching queryFn user is
  //  undefined and we return only User type, so we return default user to avoid undefined value and type error
};
